import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FileCheck,
  Phone,
  HelpCircle,
  ShieldCheck,
  Zap,
} from "lucide-react";
import { GlobalData } from "../assets/data/GlodalData";
import seoData from "../assets/data/seo.json";
import { Helmet } from "react-helmet-async";
import {
  VisakhapatnamImg as visakhapatnamPort,
  services01,
  services02,
  services03,
  services04,
  services05,
  services06,
  services07,
  services08,
  services09
} from "../assets/data/Imagedata";
import LogoLoader from "../components/LogoLoader";
const sections = [
  {
    title: <>Shipping Agency / Steamer Agents</>,
    subtitle: "",
    number: "01",
    description: "We provide comprehensive vessel representation for ships of all sizes and types. Our team ensures smooth port calls, handling all berthing, operational, and administrative requirements with efficiency and speed.",
    image: services01, // Replace with your actual image variable

  },
  {
    title: <>Customs House Agent (CHA)</>,
    subtitle: "",
    number: "02",
    description: "Navigate complex customs regulations with our expert clearance services. We specialize in swift, compliant documentation and clearance for a wide range of commodities, including coal, iron ore, fertilizers, and project cargo and containerised cargo.",
    image: services02, // Replace with your actual image variable

  },
  {
    title: <>Cargo Handling: Bulk, Breakbulk, Containerized, and Project Cargo</>,
    subtitle: "",
    number: "03",
    description: "From standard containers to complex, oversized project cargo and Bulk Cargo, We offer safe and precise handling solutions. Our experienced team ensures that your cargo is loaded, stowed, and discharged with the utmost care.",
    image: services03, // Replace with your actual image variable

  },
  {
    title: <>Cargo Equipment Provision</>,
    subtitle: "",
    number: "04",
    description: "We supply the specialized heavy machinery and equipment necessary for seamless port operations. Our reliable fleet ensures that your cargo is moved safely and efficiently, minimizing turnaround times.",
    image: services04, // Replace with your actual image variable

  },
  {
    title: <>Tools and Tackles Supply</>,
    subtitle: "",
    number: "05",
    description: "Safety and precision rely on the right gear. We provide high-quality rigging equipment, tools, and tackles essential for secure cargo lifting, lashing, and handling during all phases of port operations.",
    image: services05, // Replace with your actual image variable

  },
  {
    title: <>Transportation of Bulk Materials</>,
    subtitle: "",
    number: "06",
    description: "We manage the secure and efficient surface transportation of high-volume bulk commodities. Our logistics network ensures that materials like coal, ores, fertilizers and Containerised cargo reach their destination safely and on schedule.",
    image: services06, // Replace with your actual image variable

  },
  {
    title: <>Ship Store and Provision Supply</>,
    subtitle: "",
    number: "07",
    description: "We keep your vessels fully stocked and ready for their next voyage. Our chandlery services provide high-quality provisions, fresh water, spare parts, and essential maritime stores with prompt delivery to the port.",
    image: services07, // Replace with your actual image variable

  },
  {
    title: <>Cross-Functional Supply Chain Management for Multiple Cargo</>,
    subtitle: "",
    number: "08",
    description: "Experience true end-to-end logistics. We integrate and manage every step of your supply chain from origin to final destination providing transparent, single-window control over complex, multi-cargo movements.",
    image: services08, // Replace with your actual image variable

  },
  {
    title: <>Rake, Road, and Inland Waterways Cargo Movement</>,
    subtitle: "",
    number: "09",
    description: "Optimize your delivery routes with our multimodal transport solutions. We seamlessly coordinate cargo movement across railway rakes, road networks, and inland waterways to provide the most cost-effective and timely delivery.",
    image: services09, // Replace with your actual image variable

  }
];


const { title, description, keywords, canonical, ogImage } = seoData.services;

const Services = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);



  if (loading) return <LogoLoader isLoading={loading} />;

  return (
    <div className="services-page bg-slate-50 min-h-screen">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <main>
        {/* --- Hero Section - Compact --- */}
        <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-[2s]"
            style={{ backgroundImage: `url(${visakhapatnamPort})` }}
          />
          <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]" />

          <div className="relative z-10 text-center px-4">
            <h1 className="text-[34px] font-TuskerGrotesk text-white mb-2 tracking-[0.2em] uppercase italic">
              SERVICES
            </h1>
            <p className="text-[16px] text-secondary font-bold tracking-[0.2em] uppercase">
              Your Trusted Partner in Maritime Logistics
            </p>
            <div className="w-16 h-1 bg-secondary mx-auto rounded-full mt-4"></div>
          </div>
        </section>

        {/* --- Intro Section - Tightened --- */}
        <section className="py-12 px-6 max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="space-y-4">

              <h2 className="text-[34px] md:text-[32px] font-TuskerGrotesk font-bold text-black uppercase leading-[1.1] tracking-wider">
                <span className="text-primary italic">Shivam Shipping & Logistics - SCM</span>
              </h2>
              <div className="w-16 h-1 bg-primary/20 rounded-full" />
              <div className="space-y-3 text-slate-600 text-[14px] leading-relaxed font-medium">
                <p>
                  We provide seamless, technology-driven supply chain solutions. As expert Customs House Agents and an all-vessel Ship Agency, we handle everything from bulk commodities to project cargo. Utilizing the latest GPS and tracking software, alongside strategically coordinated warehousing, we maintain total visibility over your cargo.
                </p>
                <p>
                  From mediating secure warehousing to orchestrating complex customs clearances in Paradip and beyond, our services are built on precision, transparency, and reliable execution.  </p>
              </div>

              <div className="grid grid-cols-2 gap-3 pt-2">
                <div className="flex items-center gap-2 p-3 rounded-xl bg-white border border-slate-100 shadow-sm">
                  <Zap className="text-primary w-4 h-4" />
                  <span className="font-bold text-slate-800 uppercase text-[12px] tracking-widest leading-none">Swift Execution</span>
                </div>
                <div className="flex items-center gap-2 p-3 rounded-xl bg-white border border-slate-100 shadow-sm">
                  <ShieldCheck className="text-primary w-4 h-4" />
                  <span className="font-bold text-slate-800 uppercase text-[12px] tracking-widest leading-none">Total Visibility</span>
                </div>
              </div>
            </div>

            <div className="relative hidden lg:block">
              <div className="aspect-[16/9] bg-slate-200 rounded-3xl overflow-hidden shadow-xl">
                <img
                  src={visakhapatnamPort}
                  alt="Port Operations"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white p-4 rounded-xl shadow-xl border border-slate-50">
                <div className="flex items-center gap-3">
                  <div className="text-[34px] font-bold font-TuskerGrotesk text-primary tracking-tighter leading-none">30</div>
                  <div className="text-[10px] font-bold text-slate-500 uppercase tracking-widest leading-tight">Years of<br />Excellence</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- Services Grid - Compact 
        <section className="py-16 bg-black text-white relative">
          <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
            <h2 className="text-[32px] font-TuskerGrotesk mb-2 uppercase tracking-[0.2em] italic">
              Our Core <span className="text-primary">Expertise</span>
            </h2>
            <div className="w-12 h-1 bg-primary/40 mx-auto rounded-full mb-10" />

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 ">
              {servicesList.map((service, index) => (
                <div
                  key={index}
                  className="group bg-white/25 border border-white/5 p-5 rounded-2xl hover:bg-white/10 transition-all duration-300 text-left"
                >
                  <div className="mb-4 inline-flex p-3 bg-primary/10 rounded-lg">
                    <service.icon className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="text-[18px] text-primary font-bold mb-2 uppercase group-hover:text-primary transition-colors leading-tight">
                    {service.title}
                  </h3>
                  <p className="text-slate-100 text-[12px] leading-relaxed font-medium">
                    {service.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>--- */}





        {/*Cards Section */}
        <div className="relative">
          {sections.map((sec, index) => (
            <div
              key={index}
              className="h-[80vh] sticky top-[10vh] flex items-center justify-center overflow-hidden"
            >
              {/* Background Image */}
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-1000"
                style={{ backgroundImage: `url('${sec.image}')` }}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60"></div>
              </div>

              {/* Content */}
              <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-8">
                <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
                  {/* Left Column */}
                  <div>
                    {/* Section Number */}
                    <div className="text-[34px] font-bold text-white/10 mb-2 md:mb-4 tracking-tighter">
                      {sec.number}
                    </div>

                    {/* Title & Subtitle */}
                    <div className="mb-4 md:mb-6">
                      <div className="text-white/80 text-[14px] font-semibold tracking-widest uppercase mb-1">
                        {sec.subtitle}
                      </div>
                      <h1 className="text-[34px] font-TuskerGrotesk font-bold text-white leading-[1.1] uppercase">
                        {sec.title}
                      </h1>
                    </div>

                    {/* Description */}
                    <p className="text-[16px] text-white/90 mb-6 md:mb-8 leading-relaxed max-w-lg">
                      {sec.description}
                    </p>


                  </div>


                </div>


              </div>

              {/* Scroll hint for first section */}
              {index === 0 && (
                <div className="z-50 absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
                  <div className="text-white text-center">
                    <div className="text-sm mb-2 opacity-70">
                      Scroll to explore
                    </div>
                    <div className="w-6 h-10 border-2 border-white/50 rounded-full mx-auto flex justify-center">
                      <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>


        {/* --- Final CTA Section - Compact --- */}
        <section className="py-12 px-6 text-center max-w-4xl mx-auto">
          <h2 className="text-[34px] font-TuskerGrotesk text-black mb-6 uppercase tracking-wider">
            <span className="text-primary">Ready to</span>  Begin?
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contactus" className="w-full sm:w-auto bg-black text-white px-8 py-3 rounded-xl font-bold hover:bg-primary transition-all flex items-center justify-center gap-2 shadow-lg text-[14px]">
              <FileCheck className="w-4 h-4" /> REQUEST QUOTE
            </Link>
            <a href={`tel:${GlobalData.company.companyPhone}`} className="w-full sm:w-auto bg-white border-2 border-slate-100 text-slate-800 px-8 py-3 rounded-xl font-bold hover:border-primary transition-all flex items-center justify-center gap-2 text-[14px]">
              <Phone className="w-4 h-4" /> CONTACT US
            </a>
          </div>
          <p className="mt-8 flex items-center justify-center gap-2 text-slate-400 text-[10px] font-bold tracking-widest uppercase">
            <HelpCircle className="w-3 h-3 text-primary" /> Questions? See our <Link to="/frequently-asked-questions" className="text-primary hover:underline">FAQ Page</Link>
          </p>
        </section>
      </main>
    </div>
  );
};

export default Services;
